import styled from 'astroturf/react';
import Svg from 'src/components/Svg';
import TableBaseLink from './TableBaseLink';

const Link = styled(TableBaseLink)`
  transition: var(--ph-background-transition);
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0;
  position: relative;

  &:hover {
    background-color: rgba(var(--ph-gray-rgb-50), 0.8);
    text-decoration: none;
    border-radius: var(--ph-border-radius-sm);
  }

  &:hover > div[class*='DeleteButtonWrapper'] {
    display: block;
  }

  &.wrapped > div {
    white-space: break-spaces;
  }

  &.wrapped > div > span {
    white-space: nowrap;
    margin-bottom: 5px;
  }

  &.editable {
    cursor: default;

    &:hover {
      background-color: transparent;
    }

    & + & {
      margin-top: -3px;
    }
  }
`;
const TableContainer = styled('div')`
  position: relative;
  top: -24px;   

  & > div[class*='table'] {
      min-height: 600px;

      & > div[class*='-loading '] {      
        top: 25px;
      }   

      & > div[class*='rt-table']{ 
        & > div[class*='rt-tbody']{  
          & > div[role='rowgroup']{
            min-height: 550px;
            background: var(--white);;
          }
        }
        
      } 
      div[class*='rt-tr']:hover{
        div[class*='deleteButton'] {
          display: block;
        }
      } 
      [role*='cell']{
        [id*='icon-eye-cross']{
            display: none;
        }
      }

      [role*='cell']:last-child{
          [id*='icon-eye-cross']{
              display: block;
          }
      }
  }     
`;
const HeaderBlock = styled('div')`
  float: right;
  position: absolute;
  top: -20px;
  right: 25px;
  z-index: 9;
  
  @media screen and (max-width: 600px) {
    position: unset;
  }
`;
const DeletedBlock = styled('div')`
  float: right;
  z-index: 2;
  transition: var(--ph-button-transition);
  font-family: var(--ph-font-family-franklin-medium-regular);
  color: var(--ph-gray-500);
  display: inline-flex;
  appearance: none;
  align-items: center;
  justify-content: center;
  user-select: none;
  touch-action: manipulation;
  text-transform: none;
  white-space: nowrap;
  vertical-align: middle;
  line-height: 2.5;
  outline: none;
  font-size: var(--ph-text-sm);
  padding-left: 12px;
  padding-right: 12px;
  height: 32px;
  min-width: 32px;
  border: 0;
  cursor: pointer;
`;

const DeletedIconWrapper = styled('div')`
  display: inline-block;
  border-radius: var(--ph-border-radius-sm);
  margin-left: 15px;
  position: relative;
  top: 5px;
`;

const DeletedIcon = styled(Svg)`
  width: 16px;
  height: 16px;
`;

export default {
  Link,
  TableContainer,
  HeaderBlock,
  DeletedBlock,
  DeletedIconWrapper,
  DeletedIcon,
};
